import { SparkleContext } from "../context";
import React from "react";
/**
 * Wraps children in the host application's link component provided via
 * SparkleContext (e.g. next/link) when `href` is set, and renders children
 * as-is otherwise. Use it inside Sparkle components that can act as links so
 * consuming apps get client-side navigation.
 *
 * @summary Context-aware link wrapper.
 */
export const LinkWrapper = React.forwardRef(({ children, href, rel, replace, shallow, target, prefetch, className, tabIndex, ...rest }, ref) => {
    const { components } = React.useContext(SparkleContext);
    if (href) {
        return (React.createElement(components.link, { ref: ref, href: href, target: target, rel: rel, replace: replace, shallow: shallow, prefetch: prefetch, className: className, tabIndex: tabIndex, ...rest }, children));
    }
    return children;
});
//# sourceMappingURL=LinkWrapper.js.map